
/* injects from baggage-loader */

'use strict';
import summaryDialogTpl from '!!file-loader?name=templates/[name].[ext]!./summaryDialog.html';
import summaryDialogController from './summaryDialog.controller';

/**
 * Service to show summary dialogs.
 *
 * @param {*}
 */
function summaryDialogService($mdDialog) {
	'ngInject';

	return {
		showSummaryDialog: showSummaryDialog,
		showErrorSummaryDialog: showErrorSummaryDialog
	};

	/**
	 * Show summary dialog with components to assign.
	 *
	 * @param {*} title
	 * @param {*} user
	 * @param {*} components
	 */
	function showSummaryDialog(title, processType, user, components) {
		return showDialog(title, processType, user, components, false)
	}

	/**
	 * Show summary dialog with rejected components.
	 *
	 * @param {*} title
	 * @param {*} components
	 */
	function showErrorSummaryDialog(title, processType, components) {
		return showDialog(title, processType, '', components, true)
	}

	/**
	 * Show modal dialog.
	 *
	 * @param {*} title
	 * @param {*} user
	 * @param {*} components
	 * @param {*} isErrorDialog
	 */
	function showDialog(title, processType, user, components, isErrorDialog) {
		return $mdDialog.show({
			locals: { title: title, processType: processType, user: user, components: components, isErrorDialog: isErrorDialog},
			parent: angular.element(document.body),
			controllerAs: 'dialogvm',
			templateUrl: summaryDialogTpl,
			controller: summaryDialogController,
			clickOutsideToClose: false,
			escapeToClose: false
		});
	}

}

export default summaryDialogService;



// WEBPACK FOOTER //
// ./src/app/auth/components/summary/summary.service.js